/* eslint-disable */
import React from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import "./DashboardSection.css";
import DownloadButton from "../../atomicComponents/DownloadButton/DownloadButton";
import NewInfoIcon from "../ProcureToPayComp/TileComp/NewInfoIcon";

const DashboardSectionDropDown = ({
  title,
  children,
  showDetailView = true,
  disableDetailView = false,
  showDownloadView,
  detailPath,
  detailState = {},
  CostElement,
  handleCostElementChange,
  CostElementOption,
  onDownload,
  showInfoIcon = true,
  disableInfoIcon = false,
  popupContent,
}) => {
  const history = useHistory();

  const handleDetailClick = () => {
    if (detailPath) {
      history.push(detailPath, detailState);
    }
  };
  
  const titleStyle = {
    color: "white",
    fontSize: "0.72rem",
    fontWeight: 500,
    fontFamily: "Roboto",
    lineHeight: "1.2",
  };    

  return (
    <div className="dashboard-section">
                    { showInfoIcon && !disableInfoIcon && (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
      <div style={titleStyle}>{title || "Metric Name"}</div>
      <NewInfoIcon popupContent={popupContent} inlineMode={true} />
    </div>
      )}
      <div className="dashboard-section-header d-flex align-items-center justify-content-between">
        {/* Left side: Title */}
        <h3 className="mb-0">{title}</h3>

        {/* Right side: Dropdown + Detailed View button */}
        <div className="d-flex align-items-center gap-2">
          {CostElementOption && (
            <div style={{ width: "220px" }}>
              <Select
                value={CostElement}
                onChange={handleCostElementChange}
                options={CostElementOption}
                isSearchable={false}
              />
            </div>
          )}

          {showDownloadView && (
            <DownloadButton 
            // onClick={() => downloadDataDyanmically({}, "New Business")}
            onClick={() => onDownload && onDownload(title)}
            color="green" />
          )}

          {showDetailView && !disableDetailView && (
            <button className="detail-view-btn" onClick={handleDetailClick}>
              Detailed View <span className="arrow">»</span>
            </button>
          )}
        </div>
      </div>

      {/* Section Body */}
      <div className="dashboard-section-body">{children}</div>
    </div>
  );
};

export default DashboardSectionDropDown;

